import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import foldersAPI from "../Api/foldersAPI";
import cloneDeep from "lodash.clonedeep";
import { Button, Typography } from "@material-ui/core";
import { useUser } from "../Contexts/user";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    height: "60vh",
  },
  formControl: {
    margin: theme.spacing(1),
    width: "50%",
  },
  bouton: {
    marginTop: 30,
    width: 300,
  },
}));

export default function SelectClient({ onSelect }) {
  const classes = useStyles();
  const [clientsDevis, setClientsDevis] = useState([]);
  const [clientsForfait, setClientsForfait] = useState([]);
  const [client, setClient] = useState();
  const { token } = useUser();

  useEffect(() => {
    console.log(token);
    if (token)
      foldersAPI
        .getFolders(token, true)
        .then((res) => Promise.resolve(formatDataFolders(res.data)))
        .then((res) => {
          const clientFolder = res[0].childIds.find((c) =>
            c.title.includes("Clients - Actifs")
          );
          const clientDevis = clientFolder.childIds
            .find((c) => c.title.includes("Devis"))
            .childIds.sort((a, b) => (a.title > b.title ? 1 : -1));
          const clientForfait = clientFolder.childIds
            .find((c) => c.title.includes("Forfait"))
            .childIds.sort((a, b) => (a.title > b.title ? 1 : -1));
          setClientsDevis(clientDevis);
          setClientsForfait(clientForfait);
        });
  }, []);

  const formatDataFolders = (res) => {
    let folders = cloneDeep(res.filter((folder) => folder.childIds.length > 0));
    res.forEach((folder) => {
      let childIndex;
      let parent = res.find((f) => {
        childIndex = f.childIds.indexOf(folder.id + "");
        return childIndex > -1 ? true : false;
      });
      if (parent) {
        parent.childIds[childIndex] = folder;
        let index = folders.findIndex((f) => f.id === folder.id);
        if (index > -1) {
          folders.splice(index, 1);
        }
      }
    });
    folders = folders.map((folder) => folder.id);
    return res.filter((folder) => folders.includes(folder.id));
  };

  const displayClient = () => {
    if (client) {
      onSelect(client);
    }
  };

  return (
    <>
      <Typography
        component="h1"
        variant="h6"
        color="inherit"
        noWrap
        className={classes.title}
      >
        Sélectionnez un client
      </Typography>
      <FormControl className={classes.formControl}>
        <InputLabel htmlFor="grouped-select">Clients</InputLabel>
        <Select
          defaultValue=""
          id="grouped-select"
          onChange={(e) => setClient(e.target.value)}
        >
          <ListSubheader disableSticky="true">Forfait</ListSubheader>
          {clientsForfait.map((forfait) => (
            <MenuItem value={forfait} key={forfait.id}>
              {forfait.title}
            </MenuItem>
          ))}
          <ListSubheader disableSticky="true">Devis</ListSubheader>
          {clientsDevis.map((devis) => (
            <MenuItem value={devis} key={devis.id}>
              {devis.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        variant="contained"
        color="primary"
        className={classes.bouton}
        onClick={displayClient}
      >
        Afficher
      </Button>
    </>
  );
}
